import React, { useEffect } from "react";
import { useState } from 'react'
import api from "../api";
import { useParams, useNavigate } from "react-router-dom";
import PatientModuleLayout from "../components/patients/layout/PatientModuleLayout";
import PatientModuleHeader from "../components/patients/layout/PatientModuleHeader";
import TextInput from "../components/TextInput";
import SelectInput from "../components/SelectInput";
import RadioButtons from "../components/RadioButtons";
import FileInput from "../components/FileInput";
import InlineCheckbox from "../components/InlineCheckbox";
import TextArea from "../components/TextArea";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function NoticesPage() {

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true)
    const [loading, setLoading] = useState(false)
    const [notice, setNotice] = useState(undefined)
    const [success, setSuccess] = useState(false)
    const navigate = useNavigate();
    const [error, setError] = useState({});

    const handleChange = (field, value) => setNotice((prev) => ({ ...prev, [field]: value }));

    const handleSubmit = (event) => {
        event.preventDefault()
        setSuccess(false);
        setLoading(true);
        setError({});
        api.notices.update(1, notice).then((response) => (setSuccess(true), setLoading(false))).catch((error) => setError(error))
    };

    useEffect(() => {
        api.notices.getOne(1).then((response) => setNotice(response)).catch((error) => (setError(error), setLoading(false)))
    }, [])

    return (
        <PatientModuleLayout
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            currentScreen="Comunicados"
            header={
                <PatientModuleHeader
                    pages={[{ name: 'Comunicados', href: '#', current: true }]}
                    onToggleSidebar={() => setSidebarOpen(true)}
                    mobileBackLabel="Comunicados"
                />
            }
        >
                <div className="flex flex-col flex-1 sm:ml-6 mt-6">
                    <form onSubmit={(event) => handleSubmit(event)}>
                        <div className="flex flex-col flex-1 gap-6 mt-6 divide-gray-200 px-4 sm:px-10 w-full sm:w-2/3">
                            <p className="text-xl font-semibold dark:text-white">Comunicados</p>
                            <TextInput errorMessage={error?.title} value={notice?.title} name='title' label='Título' handleChange={handleChange} />
                            <TextArea error={error?.description} value={notice?.description} name='description' label='Mensaje' handleChange={handleChange} />
                            <InlineCheckbox value={notice?.show} name='show' label='Mostrar comunicado' handleChange={handleChange} />
                            {success &&
                                <div className="bg-white border border-gray-300 dark:border-gray-700 mt-4 w-fit py-2 px-4 rounded-xl">
                                    Sus cambios han sido guardados exitosamente.
                                </div>
                            }
                            <button type="submit" className="col-span-2 w-1/2 mx-auto flex justify-center py-2 px-4 border dark:border-gray-700 border-transparent rounded-md  shadow-sm text-sm font-medium text-white bg-primary ">
                                {loading ? <div className="w-5 h-5 mx-5 border-b-2 border-white rounded-full animate-spin"></div> : 'Guardar cambios'}
                            </button>
                        </div>
                    </form>
                </div>
        </PatientModuleLayout>
    );
}
